import React from 'react'
import { connect, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { Box, IconButton, Modal, Paper, Tooltip, withStyles } from '@material-ui/core'
import { Close } from '@material-ui/icons'
import { Label } from '../default'
import { acGetAllFilters, acDeleteFilter } from '../../class/actions'
import { Loader, Alert, PrimaryButton } from '../default'

function RemoveFilterModal({
    classes, open, onClose,
    filterToBeRemoved, deletingFilter, deleteFilterError
}) {
    const { t } = useTranslation()
    const dispatch = useDispatch()

    const removeFilter = filterId => {

        dispatch(acDeleteFilter(filterId))
            .then(() => {
                dispatch(acGetAllFilters())
                    .catch(err => console.error(err))
                onClose()
            })
            .catch(err => console.error(err))

    }

    return (
        <Modal open={open} onClose={onClose} disableAutoFocus style={{ outline: 0 }}>
            <Paper
                square={true}
                className={classes.root + ' ' + classes.modalDiv}
            >
                <Box display='flex' alignItems='center' justifyContent='space-between'>
                    <Label v='h6'>
                        {t('modals.filters.remove.title')}
                    </Label>
                    <Tooltip title={t('default.close')}>
                        <IconButton onClick={onClose}>
                            <Close />
                        </IconButton>
                    </Tooltip>
                </Box>

                <>
                    <div>
                        {
                            <Label v='body1'>
                                {t('modals.filters.remove.text', { id: filterToBeRemoved.filter_id })}
                            </Label>
                        }
                        {
                            deleteFilterError && (
                                deleteFilterError.code === 409
                                    ? (
                                        <Alert style={{ marginTop: '15px' }} noMargin color="warning" text={t('modals.filters.remove.notificationError', { ids: deleteFilterError.description.slice(49) })} />
                                    )
                                    : <Alert style={{ marginTop: '15px' }} noMargin color="error" text={t('modals.filters.remove.error')} />
                            )
                        }
                    </div>
                    <div style={{ marginTop: '15px' }}>
                        <PrimaryButton onClick={() => removeFilter(filterToBeRemoved.filter_id)} style={{ width: '100%' }}>
                            {
                                deletingFilter ? (
                                    <Loader />
                                ) : (
                                    t('modals.filters.remove.confirmButton')
                                )
                            }
                        </PrimaryButton>
                    </div>
                </>
            </Paper>
        </Modal>
    )
}

RemoveFilterModal.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    close: PropTypes.func
}

RemoveFilterModal.defaultProps = {
    open: false,
    onClose: () => true,
}

const styles = theme => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        position: 'absolute',
        padding: theme.spacing(2),
    },
    modalDiv: {
        [theme.breakpoints.up('md')]: {
            width: '35%'
        },
        width: '100%',
        top: '10%',
        left: '50%',
        transform: 'translate(-50%, -10%)',
    }
})

const mapStateToProps = ({ ReducerFilter }) => ({
    deleteFilterError: ReducerFilter.deleteFilterError,
    deletingFilter: ReducerFilter.deletingFilter
})

export default connect(mapStateToProps)(withStyles(styles)(RemoveFilterModal))
